import {
  Navigate,
  RouteObject,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';

import { Home } from '../modules/home';
import {
  Companies,
  SavedCompany,
  BasicInfo,
  ContactInfo,
  CompaniesLayout,
  SubscriptionPlan,
  Team,
  MemberInfo,
} from '../modules/companies';
import { AuthLayout, ForgetPassword, Login } from '../modules/auth';
import { useTypedSelector } from '../hooks';
import { Main } from '../layouts';

const Root = () => {
  const { refreshToken } = useTypedSelector(state => state.auth);

  // TODO: separate each route to a file
  const authRoutes: RouteObject[] = [
    {
      path: '/',
      element: <Main />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: 'companies',
          element: <CompaniesLayout />,
          children: [
            {
              path: ':status',
              element: <Companies />,
            },
            {
              path: ':status/new-company',
              element: <SavedCompany />,
            },
            {
              path: ':status/:companyId',
              element: <SavedCompany />,
            },
            {
              path: ':status/new-company/basic-info',
              element: <BasicInfo />,
            },
            {
              path: ':status/:companyId/basic-info',
              element: <BasicInfo />,
            },
            {
              path: ':status/:companyId/contact-info',
              element: <ContactInfo />,
            },
            {
              path: ':status/:companyId/subscription-plans',
              element: <SubscriptionPlan />,
            },
            {
              path: ':status/:companyId/team',
              element: <Team />,
            },
            {
              path: ':status/:companyId/team/new-member',
              element: <MemberInfo />,
            },
            {
              path: ':status/:companyId/team/:memberId',
              element: <MemberInfo />,
            },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/" />,
    },
  ];

  const nonAuthRoutes: RouteObject[] = [
    {
      element: <AuthLayout />,
      children: [
        {
          index: true,
          path: 'login',
          element: <Login />,
        },
        {
          path: 'forget-password',
          element: <ForgetPassword />,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/login" />,
    },
  ];

  const routes = refreshToken ? authRoutes : nonAuthRoutes;

  const router = createBrowserRouter(routes);

  return <RouterProvider router={router} />;
};

export default Root;
